const moneyUtils = {
  formatMoneyString: (value: string, disableDots?: boolean): string => {
    if (!value) {
      return '';
    }

    return disableDots
      ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace(/\./g, '')
      : value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },
  formatMoney: (value: number | undefined | null, emptyFallback = '—'): string => {
    if (value === undefined || value === null) return emptyFallback;
    return value.toLocaleString('ru-RU');
  },
  parseStringWithSpacesToMoney: (value?: string): number | undefined => {
    if (!value) {
      return undefined;
    }

    return Number(value?.replace(/\s+/g, ''));
  },
};

export { moneyUtils };
